// extracted by mini-css-extract-plugin
export default {"header":"new_user_page___header___a1a59785","buttons":"new_user_page___buttons___a54e99ae"};